/**
 * Labstep
 *
 * @module components/ExperimentWorkflowLink/Action/Delete
 * @desc Action to delete ExperimentWorkflowLink
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { ExperimentWorkflowLinkActionDeleteProps } from './types';

export const ExperimentWorkflowLinkActionDelete: React.FC<
  ExperimentWorkflowLinkActionDeleteProps
> = ({ experimentWorkflowLink }) => (
  <EntityActionDelete
    entity={experimentWorkflowLink}
    confirmMessage="Are you sure want to delete the link to this experiment?"
  />
);
